import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { WarningMessage } from '../../../components/widgets';
import FormSection from '../FormSection';
import { TRANSLATE_PREFIX } from '../../consts';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.POSTBACK_OVERALL_SETUP_TAB`;

const PostbackOverallSetupTab = () => (
    <FormSection
        titleKey={`${TRANSLATE_PREFIX}.TABS.POSTBACK_OVERALL_SETUP`}
        descriptionKey={`${TAB_PREFIX}.DESCRIPTION`}
        iconName="send"
    >
        <WarningMessage
            type="info"
            showIcon={false}
            collapsible
            collapsibleTitle={`${TAB_PREFIX}.INFO_TITLE`}
            message={`${TAB_PREFIX}.INFO_CONTENT`}
        />
    </FormSection>
);

export default withLocalize(PostbackOverallSetupTab);
